export default __webpack_public_path__ + "static/BT_Benefits_Carousel_04-6c224320c8191111c29d164d0c75a19e.jpg";